const TYPES = {
  Locale: Symbol.for('Locale'),

  Api: {
    ApiClient: Symbol.for('ApiClient'),
  },

  ArmyListUnitRepository: Symbol.for('ArmyListUnitRepository'),

  Repository: {
    ArsenalArmyRepository: Symbol.for('ArsenalArmyRepository'),
    ArsenalUnitRepository: Symbol.for('ArsenalUnitRepository'),
    ArsenalUnitStepRepository: Symbol.for('ArsenalUnitStepRepository'),

    ArmyListRepository: Symbol.for('ArmyListRepository'),
    FolderRepository: Symbol.for('FolderRepository'),
    FormatRepository: Symbol.for('FormatRepository'),

    VersionRepository: Symbol.for('VersionRepository'),
    ArmyRepository: Symbol.for('ArmyRepository'),
    ArmyCategoryRepository: Symbol.for('ArmyCategoryRepository'),
    SearchRepository: Symbol.for('SearchRepository'),
    ModelRuleRepository: Symbol.for('ModelRuleRepository'),
    UnitRepository: Symbol.for('UnitRepository'),
    MagicPathRepository: Symbol.for('MagicPathRepository'),
    MapRepository: Symbol.for('MapRepository'),

    ContestRepository: Symbol.for('ContestRepository'),
    MyContestRepository: Symbol.for('MyContestRepository'),
    MyTeamRepository: Symbol.for('MyTeamRepository'),

    DraftRepository: Symbol.for('DraftRepository'),
    DraftTeamRepository: Symbol.for('DraftTeamRepository'),
    DrawRepository: Symbol.for('DrawRepository'),
    MatchRepository: Symbol.for('MatchRepository'),

    UserPreferenceRepository: Symbol.for('UserPreferenceRepository'),
    AnnoncementRepository: Symbol.for('AnnoncementRepository'),
    UserBugReportRepository: Symbol.for('UserBugReportRepository'),

    BookRepository: Symbol.for('BookRepository'),
    ArmyBookRepository: Symbol.for('ArmyBookRepository'),

    ClubRepository: Symbol.for('ClubRepository'),
    MyClubRepository: Symbol.for('MyClubRepository'),
    CategoryRepository: Symbol.for('CategoryRepository'),
    PlayerRepository: Symbol.for('PlayerRepository'),

    UserFavorite: {
      Unit: Symbol.for('UserFavoriteUnitRepository'),
    },
  },

  UnitMapper: Symbol.for('UnitMapper'),
  MagicItemCategoryMapper: Symbol.for('MagicItemCategoryMapper'),
  MagicItemMapper: Symbol.for('MagicItemMapper'),
  MagicStandardMapper: Symbol.for('MagicStandardMapper'),
  OrganisationMapper: Symbol.for('OrganisationMapper'),
  ArmyOrganisationMapper: Symbol.for('ArmyOrganisationMapper'),
  ArmyOrganisationGroupMapper: Symbol.for('ArmyOrganisationGroupMapper'),
  UnitOptionMapper: Symbol.for('UnitOptionMapper'),
  OrganisationChangeMapper: Symbol.for('OrganisationChangeMapper'),
  TroopMapper: Symbol.for('TroopMapper'),
  UnitCaracMapper: Symbol.for('UnitCaracMapper'),
  UnitOptionLimitMapper: Symbol.for('UnitOptionLimitMapper'),
  UnitTypeMapper: Symbol.for('UnitTypeMapper'),
  UnitOptionUsePointMapper: Symbol.for('UnitOptionUsePointMapper'),

  FolderMapper: Symbol.for('FolderMapper'),
  ArmyListMapper: Symbol.for('ArmyListMapper'),
  ArmyListUnitMapper: Symbol.for('ArmyListUnitMapper'),
  ArmyListOrganisationMapper: Symbol.for('ArmyListOrganisationMapper'),
  ArmyListUnitUnitOptionMapper: Symbol.for('ArmyListUnitUnitOptionMapper'),

  Mapper: {
    ArsenalArmyMapper: Symbol.for('ModelArmyMapper'),
    ArsenalUnitMapper: Symbol.for('ArsenalUnitMapper'),
    ArsenalStepMapper: Symbol.for('ArsenalStepMapper'),
    FormattingMapper: Symbol.for('FormattingMapper'),
    OrganisationPointMapper: Symbol.for('OrganisationPointMapper'),

    ArmyListUnitModelRuleTroopMapper: Symbol.for(
      'ArmyListUnitModelRuleTroopMapper',
    ),
    ArmyListUnitTroopMapper: Symbol.for('ArmyListUnitTroopMapper'),
    ModelRuleUnitTroopMapper: Symbol.for('ModelRuleUnitTroopMapper'),
    ArmyListFormatedMapper: Symbol.for('ArmyListFormatedMapper'),
    ArmyListUnitFormatedMapper: Symbol.for('ArmyListUnitFormatedMapper'),
    ArmyListUnitOptionFormatedMapper: Symbol.for(
      'ArmyListUnitOptionFormatedMapper',
    ),
    FormatErrorMapper: Symbol.for('FormatErrorMapper'),
    FormatErrorSeverityMapper: Symbol.for('FormatErrorSeverityMapper'),

    VersionMapper: Symbol.for('VersionMapper'),
    ArmyCategoryMapper: Symbol.for('ArmyCategoryMapper'),
    UnitCategoryMapper: Symbol.for('UnitCategoryMapper'),
    ArmyMapper: Symbol.for('ArmyMapper'),
    ModelRuleMapper: Symbol.for('ModelRuleMapper'),
    ModelRuleLimitMapper: Symbol.for('ModelRuleLimitMapper'),
    ModelRuleCategoryMapper: Symbol.for('ModelRuleCategoryMapper'),
    ConstraintMapper: Symbol.for('ConstraintMapper'),
    ConstraintModifierMapper: Symbol.for('ConstraintModifierMapper'),

    ContestMapper: Symbol.for('ContestMapper'),
    TeamMapper: Symbol.for('TeamMapper'),

    MagicPathMapper: Symbol.for('MagicPathMapper'),
    MagicSpellMapper: Symbol.for('MagicSpellMapper'),
    TroopCaracMapper: Symbol.for('TroopCaracMapper'),
    UnitOptionAvailabilityMapper: Symbol.for('UnitOptionAvailabilityMapper'),
    UnitOptionChangeProfilMapper: Symbol.for('UnitOptionChangeProfilMapper'),
    UnitOptionChangeModelRuleMapper: Symbol.for(
      'UnitOptionChangeModelRuleMapper',
    ),
    UnitOptionOrganisationModeMapper: Symbol.for(
      'UnitOptionOrganisationModeMapper',
    ),
    UnitOptionMagicItemCategoryMapper: Symbol.for(
      'UnitOptionMagicItemCategoryMapper',
    ),
    VersionGameMapper: Symbol.for('VersionGameMapper'),
    ArmyOrganisationGroupLimitMapper: Symbol.for(
      'ArmyOrganisationGroupLimitMapper',
    ),
    OrganisationChangeAvailabilityMapper: Symbol.for(
      'OrganisationChangeAvailabilityMapper',
    ),
    SpellDurationMapper: Symbol.for('SpellDurationMapper'),
    SpellTypeMapper: Symbol.for('SpellTypeMapper'),
    MapMapper: Symbol.for('MapMapper'),
    ModelRuleChangeProfilMapper: Symbol.for('ModelRuleChangeProfilMapper'),
    ModelRuleChangeModelRuleMapper: Symbol.for(
      'ModelRuleChangeModelRuleMapper',
    ),

    BookMapper: Symbol.for('BookMapper'),
    ArmyBookMapper: Symbol.for('ArmyBookMapper'),
    BookSectionMapper: Symbol.for('BookSectionMapper'),

    TypeLvlMapper: Symbol.for('TypeLvlMapper'),

    DraftMapper: Symbol.for('DraftMapper'),
    DraftTeamMapper: Symbol.for('DraftTeamMapper'),
    DrawMapper: Symbol.for('DrawMapper'),
    MatchMapper: Symbol.for('MatchMapper'),
    TeamArmyMapper: Symbol.for('TeamArmyMapper'),

    UserPreferenceMapper: Symbol.for('UserPreferenceMapper'),
    AnnoncementMapper: Symbol.for('AnnoncementMapper'),
    UserBugReportMapper: Symbol.for('UserBugReportMapper'),

    ClubMapper: Symbol.for('ClubMapper'),
    FederationCategoryMapper: Symbol.for('FederationCategoryMapper'),
    PlayerMapper: Symbol.for('PlayerMapper'),

    UserFavorite: {
      Unit: Symbol.for('UserFavoriteUnitMapper'),
    },
  },

  Actions: {
    MyArsenalAction: Symbol.for('MyArsenalAction'),
    ArsenalArmiesAction: Symbol.for('ArsenalArmiesAction'),
    ArsenalUnitAction: Symbol.for('ArsenalUnitAction'),
    ArsenalUnitStepAction: Symbol.for('ArsenalUnitStepAction'),

    FoldersAction: Symbol.for('FoldersAction'),
    MyFolderAction: Symbol.for('MyFolderAction'),
    ArmyListAction: Symbol.for('ArmyListAction'),
    ArmyListUnitAction: Symbol.for('ArmyListUnitAction'),
    ArmyListsAction: Symbol.for('ArmyListsAction'),

    ArmyAction: Symbol.for('ArmyAction'),
    ArmyCategoriesAction: Symbol.for('ArmyCategoriesAction'),
    ArmyCategoryAction: Symbol.for('ArmyCategoryAction'),
    ArmiesAction: Symbol.for('ArmiesAction'),
    VersionsAction: Symbol.for('VersionsAction'),
    ModelRulesAction: Symbol.for('ModelRulesAction'),
    MagicPathAction: Symbol.for('MagicPathAction'),
    MapsAction: Symbol.for('MapsAction'),
    MapAction: Symbol.for('MapAction'),
    ArmyListUnitModelRuleTroopAction: Symbol.for(
      'ArmyListUnitModelRuleTroopAction',
    ),

    BookAction: Symbol.for('BookAction'),
    BooksAction: Symbol.for('BooksAction'),

    ContestsAction: Symbol.for('ContestsAction'),
    MyContestsAction: Symbol.for('MyContestsAction'),
    MyContestAction: Symbol.for('MyContestAction'),
    MyTeamsAction: Symbol.for('MyTeamsAction'),

    SyncAction: Symbol.for('SyncAction'),
    ArmyListUnitUnitOptionAction: Symbol.for('ArmyListUnitUnitOptionAction'),
    ArmyListUnitOptionAction: Symbol.for('ArmyListUnitOptionAction'),
    ArmyListUnitUnitOptionChangeProfilAction: Symbol.for(
      'ArmyListUnitUnitOptionChangeProfilAction',
    ),

    ArmyListOrganisationAction: Symbol.for('ArmyListOrganisationAction'),

    NinthAge: {
      FavoriteUnit: {
        UserFavoriteUnitsAction: Symbol.for('UserFavoriteUnitsAction'),
      },
    },

    Publication: {
      BooksAction: Symbol.for('BooksAction'),
      BookAction: Symbol.for('BookAction'),
      BookSectionAction: Symbol.for('BookSectionAction'),
      ArmyBooksAction: Symbol.for('ArmyBooksAction'),
      ArmyBookAction: Symbol.for('ArmyBookAction'),
    },

    Federation: {
      ClubsAction: Symbol.for('ClubsAction'),
      MyClubsAction: Symbol.for('MyClubsAction'),
      CategoriesAction: Symbol.for('CategoriesAction'),
      PlayersAction: Symbol.for('PlayersAction'),
    },

    Tool: {
      DraftAction: Symbol.for('DraftAction'),
      DraftTeamAction: Symbol.for('DraftTeamAction'),
      OpponentDraftTeamAction: Symbol.for('OpponentDraftTeamAction'),
      MyDrawAction: Symbol.for('MyDrawAction'),
      MatchAction: Symbol.for('MatchAction'),

      Survey: {
        SurveyAction: Symbol.for('SurveyAction'),
        CampaignsAction: Symbol.for('CampaignsAction'),
      },
    },
    User: {
      UserPreferenceAction: Symbol.for('UserPreferenceAction'),
      AnnoncementAction: Symbol.for('AnnoncementAction'),
      UserBugReportAction: Symbol.for('UserBugReportAction'),
    },
  },

  Worker: {
    CacheManager: Symbol.for('CacheManager'),
  },
};

export { TYPES };
